const decodeFilename = value => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const sanitizeAttachmentFilename = value => {
  if (!value) return '';

  let name = String(value).trim();
  [name] = name.split(';');
  name = name.replace(/[-;]*filename\*=.*$/i, '');
  name = name.replace(/^"|"$/g, '');
  name = name.substring(name.lastIndexOf('/') + 1);

  return name.trim();
};

const filenameFromUrl = url => {
  const segment = url.substring(url.lastIndexOf('/') + 1);
  const cleanSegment = segment.split('?')[0].split('#')[0];
  return cleanSegment ? decodeFilename(cleanSegment) : '';
};

export const getAttachmentFilename = attachment => {
  if (!attachment) return '';

  const explicitName = attachment.filename || attachment.fileName;
  if (explicitName) {
    return sanitizeAttachmentFilename(decodeFilename(String(explicitName)));
  }

  const url = attachment.dataUrl || attachment.data_url;
  if (!url) return '';

  return sanitizeAttachmentFilename(filenameFromUrl(url));
};

export const getAttachmentFileExtension = filename => {
  if (!filename) return '';

  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex <= 0 || lastDotIndex === filename.length - 1) return '';

  return filename.slice(lastDotIndex + 1).toLowerCase();
};
